import { faFileCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Routes, Route } from "react-router-dom";
import { Loader, Stack } from 'rsuite';
import { GlobalConsumer, postmaster, sessCode } from "./includes";

const Login = lazy(() => import('./pages/auth'));
const Dashboard = lazy(() => import('./pages/dashboard'));
const Media = lazy(() => import('./pages/media'));
const User = lazy(() => import('./pages/user'));
const Subject = lazy(() => import('./pages/subject'));
const Category = lazy(() => import('./pages/category'));
const DistributeCluster = lazy(() => import('./pages/distcluster'));
const DistributeSubject = lazy(() => import('./pages/distsubject'));
const Contents = lazy(() => import('./pages/contents'));
const Detail = lazy(() => import('./pages/detail'));
const Coder = lazy(() => import('./pages/coder'));
const Report = lazy(() => import('./pages/report'));

const PreLoader = () => {
    return <main><Loader center size='md' speed='slow' content="Please Wait!" vertical /></main>;
}

const Empty = () => {
    return <main style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <Stack direction='column' spacing={15}>
            <FontAwesomeIcon icon={faFileCircleXmark} size="5x" />
            <span>Page Not Found!</span>
        </Stack>
    </main>
}

const Routing = (props) => {

    const session = localStorage.getItem(sessCode);
    const { user } = props.state;

    const [ ready, setReady ] = useState(false);

    useEffect(() => {
        if (session) {
            const sess = JSON.parse(session);
            
            postmaster("auth/session", { session: sess.session }).then(response => {
                if (response.success) {
                    props.dispatch({
                        type: "SET_AUTH",
                        user: response.user
                    });
                }
                else {
                    props.dispatch({
                        type: "UNSET_AUTH"
                    });
                }
            });
        }
        setReady(true);
    }, []);

    return ready ? <Suspense fallback={<PreLoader />}>
        {user && Object.keys(user).length > 0 ?
        <Routes>
            <Route exact path="/" element={<Dashboard />} />
            <Route path="/media" element={<Media />} />
            <Route path="/user" element={<User />} />
            <Route path="/subject" element={<Subject />} />
            <Route path="/category" element={<Category />} />
            <Route path="/distro-cluster" element={<DistributeCluster />} />
            <Route path="/distro-subject" element={<DistributeSubject />} />
            <Route path="/contents" element={<Contents />} />
            <Route path="/coder" element={<Coder />} />
            <Route path="/report" element={<Report />} />
            <Route path='/articles/detail' element={<Detail />}>
                <Route path=':id' element={<Detail />} />
            </Route>
            <Route path="*" element={<Empty />} />
        </Routes> : <Routes>
            <Route exact path="/" element={<Login />} />
            <Route path='/articles/detail' element={<Detail />}>
                <Route path=':id' element={<Detail />} />
            </Route>
        </Routes>}
    </Suspense> : <PreLoader />;
}

export default GlobalConsumer(Routing);